import { Button } from "@/v2-components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/v2-components/ui/dialog";
import { useTrans } from "@/utils/useTrans";
import { useCartWithProducts } from "@/store/useCartWithProducts";
import React from "react";
import { useCurrency } from "@/hooks/useCurrency";
import { useLocale } from "@/store/locale-store";
import { OrderSummaryDeviceItems } from "@/v2-components/pages/checkout/order-summary-device-items";
import { OrderSummaryGameItems } from "@/v2-components/pages/checkout/order-summary-game-items";

export function CheckoutDialog({
  onClose,
  onCheckoutWithAdding,
  onCheckoutWithoutAdding,
}: {
  onClose: () => void;
  onCheckoutWithAdding: () => void;
  onCheckoutWithoutAdding: () => void;
}) {
  const { t } = useTrans(["shop"]);
  const cartWithProducts = useCartWithProducts();
  const currency = useCurrency();
  const { countryCode } = useLocale();
  const { gameItems, orderItems } = cartWithProducts;
  const devicesTotal = orderItems.reduce((acc, item) => acc + item.qty, 0);
  const gamesTotal = gameItems.length;
  const total = devicesTotal + gamesTotal;

  return (
    <Dialog open={true}>
      <DialogContent className="z-[100] flex max-h-[696px] max-w-[460px] flex-col px-5 laptop:p-6">
        <DialogHeader className="flex items-start">
          <DialogTitle className="text-lg font-500">
            {t("Checkout Together?")}
          </DialogTitle>
          <div onClick={onClose} className="w-8.5 cursor-pointer">
            <DialogClose className="size-6" />
          </div>
        </DialogHeader>
        <DialogDescription
          className="flex flex-1 flex-col gap-y-6 overflow-hidden text-base font-400 text-coolgray-90"
          // asChild
        >
          <div>
            <p className="text-base text-coolgray-90">
              {t(`You have {{total}} items in your bag.`, {
                total,
                defaultValue: `You have ${total} items in your bag.`,
              })}
            </p>
            <p className="text-base text-coolgray-90">
              {t("Would you like to check out everything together?")}
            </p>
          </div>
          <div className="flex-1 grow overflow-auto">
            {!!devicesTotal && (
              <OrderSummaryDeviceItems
                currency={currency}
                countryCode={countryCode}
                items={orderItems}
              />
            )}
            {!!gamesTotal && (
              <OrderSummaryGameItems
                gameItems={gameItems}
                currency={currency}
                countryCode={countryCode}
              />
            )}
          </div>
        </DialogDescription>
        <DialogFooter className="flex flex-col flex-wrap items-center justify-end gap-2 tablet:flex-row">
          <Button
            onClick={onCheckoutWithoutAdding}
            variant="blue-outline"
            shape="pill"
            size="sm"
            className="w-full !px-6 tablet:w-auto"
          >
            {t("Continue Without Adding")}
          </Button>
          <Button
            onClick={onCheckoutWithAdding}
            variant="blue-fill"
            shape="pill"
            size="sm"
            className="w-full !px-6 tablet:w-auto"
          >
            {t("Add & Continue")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
